// extracted by mini-css-extract-plugin
export default {"contentRow":"IbKUu","cover":"S2r5h","main":"jpmpz","contentContainer":"VExiU","title":"ZQR7i","link":"zqJGI","content":"_2SXIu","header":"Ti7s8","name":"_3ac00","date":"_3w9tn"};